// Cart drawer upsell interactions:
// 1. Transient "Adding..." feedback on the ADD button during the add
//    round-trip. The drawer section is morphed once the add completes, which
//    replaces or removes the card, so no reset logic is needed.
// 2. Focus restoration after the morph. The clicked button is removed from
//    the DOM, which drops focus to <body> outside the open dialog; move it
//    back into the drawer so keyboard and screen reader users keep their
//    place (WCAG 2.4.3).
(() => {
  if (window.__cartUpsellFeedback) return;
  window.__cartUpsellFeedback = true;

  let pendingRefocus = false;

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.closest('.cart-upsells__form')) return;

      const button = form.querySelector('.cart-upsells__add');
      if (!button) return;

      button.dataset.idleText = button.textContent;
      button.setAttribute('disabled', '');
      button.textContent = button.dataset.addingText || 'Adding...';
      pendingRefocus = true;
    },
    true
  );

  // A failed add (sold out mid-session, quantity rule, network error) leaves
  // the morph from happening; reset any stuck buttons so the shopper can
  // retry instead of staring at a dead "Adding...".
  document.addEventListener(
    'cart:error',
    () => {
      pendingRefocus = false;
      document.querySelectorAll('.cart-upsells__add[disabled]').forEach((button) => {
        if (!(button instanceof HTMLElement) || !button.dataset.idleText) return;
        button.textContent = button.dataset.idleText;
        button.removeAttribute('disabled');
      });
    },
    true
  );

  document.addEventListener('cart:update', () => {
    if (!pendingRefocus) return;
    pendingRefocus = false;

    setTimeout(() => {
      const active = document.activeElement;
      // Leave focus alone if it survived the morph inside the drawer.
      if (
        active &&
        active !== document.body &&
        document.contains(active) &&
        active.closest('cart-drawer-component')
      ) {
        return;
      }

      // Drawer when open, main cart page otherwise.
      const scope =
        document.querySelector('cart-drawer-component dialog[open]') ||
        document.querySelector('.cart-page');
      if (!scope) return;

      const target =
        scope.querySelector('.cart-upsells__add:not([disabled])') ||
        scope.querySelector('.cart-drawer__close-button') ||
        scope.querySelector('#checkout');
      if (target instanceof HTMLElement) target.focus();
    }, 50);
  });
})();
